import { forwardRef } from "react";

import { Anchor, Button, LockHollowSVG } from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import SelectedStateIndicator from "@/components/SelectedStateIndicator";
import ChevronRightIcon from "@/icons/ChevronRightIcon";
import {
  buttonContentsWrapperCss,
  buttonTextCss,
  iconWrapperCss,
  popOutOptionCss,
  hideOpenInNewTabIconCss,
} from "./ActionPopOutOption.style";

const propTypes = {
  ariaProps: PropTypes.object,
  dataProps: PropTypes.object,
  disabled: PropTypes.bool,
  eventProperties: PropTypes.object.isRequired,
  hasSubMenu: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.node,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  showLockIcon: PropTypes.bool,
  subMenuIsActive: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

const ButtonWithTrackEvent = withTrackEvent(Button);
const AnchorWithTrackEvent = withTrackEvent(Anchor);

const ActionPopOutOption = forwardRef(
  (
    {
      ariaProps = {},
      dataProps = {},
      disabled = false,
      eventProperties,
      hasSubMenu,
      href,
      icon,
      isSelected,
      onClick,
      showLockIcon,
      subMenuIsActive,
      title,
    },
    ref,
  ) => {
    const buttonProps = {
      flavor: Button.flavors.incognito,
      size: Button.sizes.lg,
    };

    const buttonContents = (
      <span css={buttonContentsWrapperCss}>
        <span css={iconWrapperCss}>{icon}</span>
        <span css={buttonTextCss}>
          {showLockIcon && (
            <LockHollowSVG isDecorative={false} title="locked" />
          )}
          {title}
        </span>
      </span>
    );

    const ariaExpandedProps = hasSubMenu && {
      "aria-expanded": subMenuIsActive,
    };

    if (onClick) {
      return (
        <li>
          <ButtonWithTrackEvent
            __cssFor={{ root: popOutOptionCss(isSelected) }}
            ariaProps={{ ...ariaProps, ...ariaExpandedProps }}
            dataProps={dataProps}
            disabled={disabled}
            onClick={onClick}
            ref={ref}
            {...buttonProps}
            {...eventProperties}
          >
            <SelectedStateIndicator shouldDisplay={isSelected} />
            {buttonContents}
            {hasSubMenu && !showLockIcon && <ChevronRightIcon />}
          </ButtonWithTrackEvent>
        </li>
      );
    }

    return (
      <li>
        <AnchorWithTrackEvent
          __cssFor={{
            root: popOutOptionCss(false, disabled),
            Icon: {
              root: icon ? hideOpenInNewTabIconCss : {},
            },
          }}
          href={href}
          openInNewTab
          styleAnchorAsButton={buttonProps}
          dataProps={dataProps}
          {...eventProperties}
        >
          {buttonContents}
        </AnchorWithTrackEvent>
      </li>
    );
  },
);

ActionPopOutOption.propTypes = propTypes;

export default ActionPopOutOption;
